import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseResponse } from 'app/models2/commos/base-response';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService } from 'brainloper-ui';
import { environment } from 'environments/environment';
import { ModalAddDevicesComponent } from '../modal-add-devices/modal-add-devices.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceTraccar } from 'app/models2/traccar/device-traccar';
import { GenericResponse } from 'app/models2/commos/generic-response';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit, OnDestroy {

  public urlTraccar = null;
  private homeUrl: string = environment.urlTraccarWeb;
  private eventId?: string;

  private boundHandleMessage = this.handleMessage.bind(this);
  private checkIframeTimeout

  seccionActive:boolean = false;
  iframeError: boolean = false; 

    menuBreadCrumb: MenuBreadCrumb[] = [
      {
        name: 'Inicio',
        router: '/inicio',
      },
      {
        name: 'Dispositivos',
        current: true,
      },
    ];
    
  constructor(
    private sanitizer: DomSanitizer,
    private sessionService : SessionService,
    private localStorageService : LocalStorageService,
    private message : MessageService,
    private http : HttpService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute) { }

    async ngOnInit() {

      const persistentSession = this.localStorageService.get('iframeSessionStarted');
      const activeSession = this.sessionService.getData('iframeSessionStarted');

      if (persistentSession && !activeSession) {
        this.localStorageService.remove('iframeSessionStarted');
        this.router.navigate(['/inicio']);
        return;
      }


      this.route.queryParamMap.subscribe(params => {
        const evt = params.get('eventId');
        if(evt){
          this.eventId = evt;
          this.homeUrl = this.buildEventUrl(evt);
        }
      });

      await this.createSession()
      window.addEventListener('message', this.boundHandleMessage);

      this.checkIframeTimeout = setTimeout(() => {
        this.checkIframeStatus();       
      }, 300000);

    }

    async onIframeLoad(event: any) {
  
    }

    async createSession(){
      var response = await this.http.getDataBody<any>(EndpointDictionary.Traccar.CREATE_SESSION, null, true)
      if(response){

        this.localStorageService.set('iframeSessionStarted', 'true');
        this.sessionService.setData('iframeSessionStarted', 'true');

        this.seccionActive = true;  
        this.urlTraccar = this.sanitizer.bypassSecurityTrustResourceUrl(this.homeUrl);   
      } else {
        this.message.Warning("Error", "No se ha podido iniciar la sesión del mapa. Será redirigido.", false, "Aceptar", null, false).then(() => {
          this.router.navigate(['/inicio']);
        });
      }
    }

    private buildEventUrl(eventId:string){
      if(this.homeUrl.includes('?')){
        return `${environment.urlTraccarWeb}&eventId=${eventId}`;
      }
      return `${environment.urlTraccarWeb}?eventId=${eventId}`;
    }

    handleMessage(event: MessageEvent) {

      if(event.data){
        
        if (event.data.type === 'refresh-session' && event.data.status === 401) {
          this.createSession();
        }

        if (event.data && event.data.action === 'add-device-clicked') {
          this.addDevice();
        }
  
        if(event.data.action === 'delete-device-clicked') {
          this.deleteDevice(event.data.device);
        }

        if(event.data.action === 'edit-device-clicked') {
          this.editDevice(event.data.device);
        }
        
      }
    }

    addDevice() {
      const dialogRef = this.dialog.open(ModalAddDevicesComponent, {
        width: '500px',
      });

      dialogRef.afterClosed().subscribe(() => {
        this.reloadDevices();
      });
    }

    deleteDevice(device: DeviceTraccar) {
      if (!device || !device.id || !device.attributes || !device.attributes.equipmentId) {
        this.message.Error("Error", "El dispositivo o sus identificadores no son válidos.");
        return;
      }

      this.message.Warning("Eliminar Dispositivo", "¿Está seguro de eliminar el dispositivo?", true, "Eliminar", "Cancelar", false).then(async (res) => {
        if (res) {
          const url = `${EndpointDictionary.Traccar.DELETE_DEVICES.replace('{id}', device.id.toString()).replace('{equipmentId}', device.attributes.equipmentId.toString())}`;
          var response: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(url);
          if (response && response.code === 0) {
            this.message.Success("Dispositivo eliminado", "El dispositivo se eliminó correctamente.");
            this.reloadDevices();
          } else {
            this.message.Error("Error", "No se pudo eliminar el dispositivo.");
          }
        }
      });
    }

    async editDevice(device: DeviceTraccar){
      const positionResponse = await this.http.getDataBody<any>(EndpointDictionary.Traccar.LAST_POSITION_DEVICE.replace('{id}', device.id.toString()), null, true);
      let totalDistance = 0;
    if (positionResponse ) {
      totalDistance = Math.floor(positionResponse.totalDistance || 0);
    }

    const deviceData = {
      ...device,
      totalDistance: totalDistance
    };
      const dialogRef = this.dialog.open(ModalAddDevicesComponent, {
        width: '500px',
        data: deviceData
      });

      dialogRef.afterClosed().subscribe(() => {
        this.reloadDevices();
      });
    }

    checkIframeStatus() {
      if (!this) {
        return;
      }

      const iframe = document.getElementById('traccarIframe') as HTMLIFrameElement;
      if (iframe) {
        try {
          if (!iframe.contentWindow || iframe.src === '' || iframe.src === 'about:blank') {
            this.iframeError = true;
            console.warn('Iframe not loaded correctly. Setting iframeError to true.');
          } else {
            this.iframeError = false;
          }
        } catch (error) {
          this.iframeError = true;
          console.error('Error checking iframe status:', error);
        }
      } else {
        console.warn('Iframe element not found.');
        this.iframeError = true;
      }

      if(this.iframeError){
        this.message.Warning("Error", "No se ha podido cargar los dispositivos. Por favor, intente nuevamente.", false, "Aceptar", null, false).then((res) => {
          if(res){
            this.router.navigate(['/inicio']);
          }
        });
      }
    }

    private reloadDevices(){
      const iframe = document.getElementById('traccarIframe') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage('reloadDevices', '*');
      }
    }
    
    ngOnDestroy() {
      if (this.checkIframeTimeout) {
        clearTimeout(this.checkIframeTimeout);
        this.checkIframeTimeout = null;
      }
      
      window.removeEventListener('message', this.boundHandleMessage);
    }

}
